import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import type { IMessage } from '@/types/admin/messages';
import { CHAT_MOBILE_COLORS } from '@/constants/residents/mobile/chatColors';
import { isMessageSentByUser, formatSenderName } from '@/utils/residents/messages/messageUtils';
import { formatMessageTime } from '@/utils/common/formatting';

export const MessageBubbleMobile: React.FC<{ message: IMessage; authUserId?: number }> = ({ message, authUserId }) => {
  const sentByYou = isMessageSentByUser(message.sender?.id, authUserId, message.isAdmin);

  const bubbleStyle = {
    alignSelf: sentByYou ? 'flex-end' as const : 'flex-start' as const,
    backgroundColor: sentByYou ? CHAT_MOBILE_COLORS.sentMessageBubble : CHAT_MOBILE_COLORS.receivedMessageBubble,
    borderTopLeftRadius: sentByYou ? 6 : 2,
    borderTopRightRadius: sentByYou ? 2 : 6,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
  };

  // Only show sender name for own messages or admin messages
  const nameString = sentByYou 
    ? formatSenderName(message, sentByYou, 'mobile')
    : message.isAdmin 
      ? formatSenderName(message, sentByYou, 'mobile')
      : '';

  return (
    <View style={[styles.messageBubble, bubbleStyle]}>
      {nameString && (
        <Text style={[styles.senderName, sentByYou && styles.senderNameSent]}>
          {nameString}
        </Text>
      )}
      {!!message.content && <Text style={styles.messageText}>{message.content}</Text>}
      <Text style={styles.timeStamp}>
        {formatMessageTime(message.createdAt)}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  messageBubble: {
    maxWidth: '80%',
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginVertical: 4,
    gap: 1,
  },
  senderName: {
    fontSize: 12,
    fontWeight: '500',
    color: CHAT_MOBILE_COLORS.textPlaceholder,
    marginBottom: 2,
    lineHeight: 18,
  },
  senderNameSent: {
    color: CHAT_MOBILE_COLORS.textLabel,
  },
  messageText: {
    fontSize: 14,
    fontWeight: '400',
    color: CHAT_MOBILE_COLORS.textPrimary,
    lineHeight: 21,
  },
  timeStamp: {
    fontSize: 12,
    fontWeight: '300',
    color: CHAT_MOBILE_COLORS.textTimestamp,
    marginTop: 1,
    textAlign: 'right',
    lineHeight: 18,
  },
});

export default MessageBubbleMobile;
